module.exports = __webpack_public_path__ + "img/gzlb- 2.e5fc56f5.jpg";